import { Button, CircularProgress } from "@mui/material";
import { AtButtonProps, AtButtonSize, AtButtonType } from "./at-button.types";
import { buttonVariants } from "./at-button-variants";
import { AtIcon } from "../at-icon";

export const AtButton = ({
  className,
  size = AtButtonSize.LARGE,
  text,
  buttonType = AtButtonType.PRIMARY,
  disabled = false,
  loading = false,
  startIcon,
  href,
  onClick,
  type = "button",
  style,
  iconSize,
}: AtButtonProps) => {
  const buttonClasses = buttonVariants({
    variant: buttonType,
    size,
  });

  const iconSizeValue = () => {
    if (iconSize) {
      return iconSize;
    }

    switch (size) {
      case AtButtonSize.EXTRA_SMALL:
      case AtButtonSize.NONE:
        return 16;
      default:
        return 24;
    }
  };

  return (
    <Button
      style={style}
      type={type}
      disabled={disabled || loading}
      href={href}
      onClick={(event) => {
        event.stopPropagation();
        onClick?.();
      }}
      startIcon={
        startIcon &&
        buttonType !== AtButtonType.ICON &&
        !loading && (
          <AtIcon
            name={startIcon}
            className="font-white"
            size={iconSizeValue()}
          />
        )
      }
      className={`${buttonClasses} ${className}`}
    >
      <span className={`${loading ? "opacity-0" : "opacity-100"}`}>{text}</span>
      {buttonType === AtButtonType.ICON && startIcon && (
        <AtIcon
          name={startIcon}
          className="font-white"
          size={iconSizeValue()}
        />
      )}
      {loading && (
        <CircularProgress
          size={16}
          className="!text-surface-300 !absolute !top-1/2 !left-1/2 !-translate-x-1/2 !-translate-y-1/2"
        />
      )}
    </Button>
  );
};
